Vendd.Scripts.load(function () {   
    window.goHome = function () {
        window.location = "/";
    }
});